// ^\s+at\s+  — matches the "    at " prefix of a stack frame line (multiline mode)
// (?:new\s+)?  — optionally matches "new " for constructor calls like "new MyClass"
// [^\s(<@[\n]+  — captures the name: stops at whitespace, "(", "<", "@", "[" (file path start chars)
const FIRST_FRAME_RE = /^\s+at\s+((?:new\s+)?[^\s(<@[\n]+)/m;

export function extractFirstStackFrame(stack: string | undefined): string {
  return FIRST_FRAME_RE.exec(stack ?? '')?.[1]?.trim() ?? '';
}

export default class CrashError extends Error {
  dd_fingerprint: string;
  constructor(error: Error) {
    super(`APPLICATION_CRASH: ${error.message}`);
    this.name = 'CrashError';
    this.stack = [this.stack?.split('\n').slice(0, 2).join('\n'), error.stack].filter(Boolean).join('\n');
    this.dd_fingerprint = `APPLICATION_CRASH:${error.message}:${extractFirstStackFrame(error.stack)}`;
  }
}